import React, { useState, useEffect } from 'react';
import {
	Card,
	CardBody,
	CardHeader,
} from '../../../../_metronic/_partials/controls';
import { Button } from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { getTranslationsByEntityId } from '../../../../api/translation';
import { useSkeleton } from '../../../hooks/useSkeleton';
import { alertError } from '../../../../utils/logger';
import { shallowEqual, useSelector } from 'react-redux'
import PlansContent from '../../../components/plansContent';
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock';
import { getNutritionalPlanById } from '../../../../api/nutritionalPlan';

export default function NutritionalPlansTranslationsPage() {
	const [translations, setTranslations] = useState([])
	const [nutritionalPlan, setNutritionalPlan] = useState(null)
	const nutritionalPlanId = useParams().id;
	const history = useHistory();
	const user = useSelector((store) => store.authentication?.user, shallowEqual)

	const {
		isLoading: isLoadingData,
		disableLoading: disableLoadingData,
		ContentSkeleton,
	} = useSkeleton();

	useEffect(() => {
		if (!nutritionalPlanId) {
			disableLoadingData();
			alertError({ error: null, customMessage: 'Could not get nutritional plan translations.' });
			history.push('/nutritional-plans');
			return;
		}
		getTranslationsByEntityId(nutritionalPlanId)
			.then((res) => {
				if (res.status === 200) {
					getNutritionalPlanById(nutritionalPlanId)
						.then(response => {
							if (response.status === 200) {
								let translations = {}
								const { title, description, plan, ..._nutritionalPlan } = response.data
								setNutritionalPlan({
									..._nutritionalPlan, 
									standard: !_nutritionalPlan.nutritionist
								})
								translations.es = { title, description, plan }
								for (const translation of res.data) {
									const content = translation.content
									translations[translation.langIsoCode] = content
								}
								setTranslations(translations);
								disableLoadingData();
							}
						})
						.catch((error) => {
							alertError({ error: error, customMessage: 'Could not get nutritional plan.' });
							history.push('/nutritional-plans');
						});
				}
			})
			.catch((error) => {
				alertError({ error: error, customMessage: 'Could not get nutritional plan translations.' });
				history.push('/nutritional-plans');
			});

		
	}, [nutritionalPlanId, disableLoadingData, history]);

	const renderMultilanguageTabContent = (lang, langName) => {
		const canEdit = user?.role.includes('admin') || (nutritionalPlan?.nutritionist === user?._id && !nutritionalPlan?.standard)
		return <>
			<br/>
			{translations && translations[lang] ? <PlansContent 
				plan={{...translations[lang], ...nutritionalPlan}} 
				user={user}
				type="nutritional"
				showTitle={true}
			/> : <>
				<p>There is no translation into this language yet.</p>
			</>}
			<br/>
			{canEdit && <Button
				onClick={() => {
					if (lang === 'es') history.push('/edit-nutritional-plan/' + nutritionalPlanId)
					else history.push('/translate-nutritional-plan/' + nutritionalPlanId + '/' + lang)
				}}
				variant='outlined'
				color='primary'>
				{'Edit ' + langName}
			</Button>}
		</>
	}

	if (isLoadingData) return <ContentSkeleton />;
	else
		return (
			<>
				<Card>
					<CardHeader title='View nutritional plan translations'/>
					<CardBody>
						<MultilanguageTabBlock
							multilanguageTabContent={renderMultilanguageTabContent}
						/>
					</CardBody>
				</Card>
				<div style={{ display: 'flex', flexDirection: 'row' }}>
					<Button
						onClick={() => history.push('/nutritional-plans')}
						variant='outlined'
						style={{ marginRight: '20px' }}>
						Back
					</Button>
				</div>
			</>
		);
}
